import { useEffect } from 'react';

function upsertLink(rel: string, href: string, type?: string) {
  const selector = type
    ? `link[rel="${rel}"][type="${type}"]`
    : `link[rel="${rel}"]`;
  let link = document.querySelector<HTMLLinkElement>(selector);

  if (!link) {
    link = document.createElement('link');
    link.rel = rel;
    if (type) link.type = type;
    document.head.appendChild(link);
  }

  link.href = href;
}

export function useFavicon(iconUrl?: string | null) {
  useEffect(() => {
    if (!iconUrl) return;
    upsertLink('icon', iconUrl);
    upsertLink('apple-touch-icon', iconUrl);
  }, [iconUrl]);
}
